module.exports = __webpack_public_path__ + "img/girl-lights.0a974bee.jpg";